import { computed } from 'vue';
import { useStore } from "vuex";
import yup from '@component_path/inquiry_form_common_module/customValidation';

export const useWishfulTimeField = (required, messages = {}) => {
  const fieldName = computed(() => 'wishful_time');

  const validator = yup.string()
    .requirement(required, messages['requirement'] || '希望就業時期は必須項目です');

  return { validator, fieldName }
}


export const useWishfulTimeStore = () => {
  const store = useStore();
  const wishfulTime = computed(() => store.state.formData.wishful_time);
  const wishfulTimes = computed(() => store.state.masterData.wishful_times);
  const dispatcher = computed(() => 'formData/setWishfulTime');

  return { wishfulTime, wishfulTimes, dispatcher }
}